import { regex } from '../../validator/isDataType';

const NAME_REGEX = /^[a-zA-Z ]*$/;
const PHONE_REGEX = /^[0-9]{10}$/;

// `labels` comes from CDN content (components.loans.registration_form.fields); falls back to
// the English defaults below until that content has loaded.
export const getLoanApplicationFormFields = (labels = {}) => [
  {
    type: 'TEXT',
    id: 'firstName',
    name: 'firstName',
    displayName: labels.firstName || 'First Name',
    value: '',
    validation: {
      rule: {
        required: { isRequired: true },
        regex: { pattern: NAME_REGEX },
        length: { max: 20 }
      }
    },
    // error: '',
    fullWidth: false
  },
  {
    type: 'TEXT',
    id: 'lastName',
    name: 'lastName',
    displayName: labels.lastName || 'Last Name',
    value: '',
    validation: {
      rule: {
        required: { isRequired: true },
        regex: { pattern: NAME_REGEX },
        length: { max: 20 }
      }
    },
    error: '',
    fullWidth: false
  },
  {
    type: 'TEXT',
    id: 'phoneNumber',
    name: 'phoneNumber',
    displayName: labels.phoneNumber || 'Phone Number',
    value: '',
    validation: {
      rule: {
        required: { isRequired: true },
        regex: { pattern: PHONE_REGEX },
        length: { max: 10 }
      }
    },
    error: '',
    fullWidth: false
  },
  {
    type: 'TEXT',
    id: 'email',
    name: 'email',
    displayName: labels.email || 'Email ID',
    value: '',
    validation: {
      rule: {
        required: { isRequired: true },
        regex: { pattern: regex.email },
        length: { max: 50 }
      }
    },
    error: '',
    fullWidth: false
  }
];

export const loanApplicationFormFields = getLoanApplicationFormFields();

